import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { GenerateNodeScriptDialogBody, GenerateNodeScriptDialogProps, GenerateNodeScriptDialogState } from '~src/settings/dataconnect-settings/sections/dataConnectMultiPool/GenerateNodeScriptDialog';
import { BaasEdgePool } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePool';

import { IDownloadScriptParams, IDownloadScriptResult } from '../../serverApi/requests/DownloadScript';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';

const buttonsContainerStyle = style({
  padding: 5,
  borderBottom: `1px solid ${TabStyles.Colors.L2_5}`,
  background: 'white',
  display: 'flex',
});

const innerContainerStyle = style({
  width: 700,
  paddingLeft: 85,
  display: 'flex',
});

export interface GenerateNodeScriptButtonProps {
  pool: UserDefinedPoolModel;
  existingPoolNames: ReadonlyArray<string>;
  siteId: string;
}


export function GenerateNodeScriptButton(props: GenerateNodeScriptButtonProps) {
  return (
    <span className={'tb-data-grid-icon tb-padded-left-small'} data-tb-test-id={'pool-actions-menu-cell'}>
        <ButtonWidget
          testId={'pool-generate-node-script'} buttonType={ButtonType.Outline}
          onClick={() => openEditPoolDialog(props.pool, props.existingPoolNames, props.siteId)}
          style={{marginRight: 10, paddingRight:5,  paddingLeft:5}}
        >
          {Messages.dataConnectSiteSettingsGenerateNodeScriptButton()}
        </ButtonWidget>
    </span>
  );
}


function openEditPoolDialog(pool: UserDefinedPoolModel, existingPoolNames: ReadonlyArray<string>, siteId: string) {
  const action = (_: GenerateNodeScriptDialogProps, state: GenerateNodeScriptDialogState) => {
    //const downloadUrl='/v1/baas/'+pool.clusterId+'/onboardNodeFile';
    const downloadScriptParam: IDownloadScriptParams = {
      clusterId: pool.clusterId,
      siteId: siteId
    };
    BaasEdgePool.downloadScript(downloadScriptParam)
      .then((result: IDownloadScriptResult) => {
        if(result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsEditPoolSuccess() });
        }
        if(result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
        });
        }
      });
    return Promise.resolve();
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.dataConnectSiteSettingsPoolAddNewNodeToPool({ POOL_NAME: pool.displayName }),
    bodyComponent: GenerateNodeScriptDialogBody,
    initialBodyProps: { description: Messages.dataConnectSiteSettingsPoolDownloadScriptDescription(),
                        cammandLine1: Messages.dataConnectSiteSettingsPoolDownloadScriptDescriptionCommand1(),
                        cammandLine2: Messages.dataConnectSiteSettingsPoolDownloadScriptDescriptionCommand2(),
                        cammandLine3: Messages.dataConnectSiteSettingsPoolDownloadScriptDescriptionCommand3(),
                        cammandLine4: Messages.dataConnectSiteSettingsPoolDownloadScriptDescriptionCommand4(),
                        cammandLine5: Messages.dataConnectSiteSettingsPoolDownloadScriptDescriptionCommand5()},
    initialDialogState: { hasError: false },
    actionName: Messages.dataConnectSiteSettingsPoolDownloadScript(),
    action: action,
    actionDisabled: (_, state: GenerateNodeScriptDialogState) => false,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width375px,
    hideCancelButton: true,
    showCloseButton: true
  });

  return Promise.resolve(dialogInstance.result);
}
